import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/$org/$agent/demand-response-admin')({});
